import bandColors from './hfv4BandColors.postcss';

// Fixed HFv4 score band data; mirrors backend ScoreBand model shape.
// To re-enable backend data, set USE_LOCAL_HFV4_SCORE_BANDS to false in this file
// and restore the fetchScoreBandIfNeeded call in StudentReportView/component.jsx.
export const USE_LOCAL_HFV4_SCORE_BANDS = true;

export const HFV4_SCORE_BANDS = [
  {
    scorePercentageFrom: 0,
    scorePercentageTo: 59,
    name: 'Needs Improvement',
    color: bandColors.colorNeedsImprovement,
    interpretation:
      'Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned.',
  },
  {
    scorePercentageFrom: 60,
    scorePercentageTo: 79,
    name: 'Developing',
    interpretation:
      'Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently.',
  },
  {
    scorePercentageFrom: 80,
    scorePercentageTo: 89,
    name: 'On Track',
    interpretation:
      'Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes.',
  },
  {
    scorePercentageFrom: 90,
    scorePercentageTo: 100,
    name: 'Outstanding',
    interpretation:
      'Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit\'s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning.',
  },
];

export const getHfv4BandForScore = (score) =>
  HFV4_SCORE_BANDS.find((b) =>
    score >= b.scorePercentageFrom && score <= b.scorePercentageTo
  );


// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/ScoreBand/hfv4ScoreBands.js